import {
  IconButton,
  Popover,
  PopoverTrigger,
  useBoolean,
} from '@chakra-ui/react';
import EditSharpIcon from '@gamma/ui/icons/EditSharpIcon';
import { i18n } from '../../../../shared/localization';

import { useState } from 'react';
import { IGetDetectionVariables } from '..';
import { DetectionQueryVariables } from '../../pages';
import { AssignUserContent } from '../DetectionActions';

const { controls } = i18n.pages.detections;

const { editAssignee } = controls;

interface DetectionAssigneePopoverProps {
  setUpdateDetectionsParam?: () => void;
  refetchMain?: boolean;
  isAssigneeHovered: boolean;
  getDetectionVariables?: IGetDetectionVariables;
  queryDetectionsPaginatedVariables?: DetectionQueryVariables;
}

export const DetectionAssigneePopover = ({
  setUpdateDetectionsParam,
  refetchMain,
  isAssigneeHovered,
  getDetectionVariables,
  queryDetectionsPaginatedVariables,
}: DetectionAssigneePopoverProps) => {
  const [isEditing, setIsEditing] = useBoolean();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  return (
    <Popover
      closeOnEsc={true}
      closeOnBlur={true}
      offset={[-145, 10]}
      isOpen={isEditing}
      onOpen={setIsEditing.on}
      onClose={setIsEditing.off}
    >
      <PopoverTrigger>
        <IconButton
          w="24px"
          h="24px"
          size="box-md"
          variant="solid"
          colorScheme="gray"
          aria-label={editAssignee}
          data-tooltip={editAssignee}
          title={editAssignee}
          data-testid="suppress-entity-popover-content-trigger"
          style={{
            visibility: isEditing || isAssigneeHovered ? 'visible' : 'hidden',
          }}
        >
          <EditSharpIcon size="sm" />
        </IconButton>
      </PopoverTrigger>
      <AssignUserContent
        refetchMain={refetchMain}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        setUpdateDetectionsParam={setUpdateDetectionsParam}
        onClose={setIsEditing.off}
        getDetectionVariables={getDetectionVariables}
        queryDetectionsPaginatedVariables={queryDetectionsPaginatedVariables}
      />
    </Popover>
  );
};
